import { canShipPurchaseOrder } from './can-ship-purchase-order.js';
export function canOfferShipPurchaseOrderAction(statusName, hasEnteredLines) {
    return canShipPurchaseOrder(statusName) && hasEnteredLines;
}
//# sourceMappingURL=can-offer-ship-purchase-order-action.js.map